import { render, staticRenderFns } from "./ration.vue?vue&type=template&id=7b05c820&scoped=true&"
import script from "./ration.vue?vue&type=script&lang=js&"
export * from "./ration.vue?vue&type=script&lang=js&"
import style0 from "./ration.vue?vue&type=style&index=0&id=7b05c820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b05c820",
  null
  
)

export default component.exports